<template>
  <div class="home__content home__watchlist">
    <loader-dots v-if="showLoader" />

    <div class="home__header">
      <h1 class="home__title">На контроле</h1>
    </div>

    <watchlist-controls
      :events="events"
      :unreadCount="unreadCount"
      :filterUnread="filterUnread"
      :curEventId="curEventId"
      :curPeriodId="curPeriodId"
      @filter-unread-click="onFilterUnreadClick"
      @menu-item-click="onMenuItemClick"
    />

    <watchlist-items  
      v-if="itemsToSee.length"
      class="home__list watchlist"
      :events="events"
      :items="items"
      :filterUnread="filterUnread"
      :curEventId="curEventId"
      :curPeriodId="curPeriodId"
      :itemsPerPage="itemsPerPage"
      :itemsTotal="itemsTotal"
      :itemsOffset="itemsOffset"
      :markedAsReadDocIds="markedAsReadDocIds"
      @button-watch-click="onButtonWatchClick"
      @toggle-read-mark="toggleReadMark"
      @paginator-update="handlePaginatorUpdate"
    />
  </div>
</template>

<script>
/* eslint-disable */
import apiUser from '@src/api/user';

import { mapGetters } from 'vuex';

import WatchlistControls from './WatchlistControls'
import WatchlistItems from './WatchlistItems'

import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    WatchlistControls,
    WatchlistItems,
    LoaderDots
  },

  data: () => ({
    filterUnread: true,
    curEventId: null,
    curPeriodId: null,

    itemsPerPage: 20,
    itemsOffset: 0,

    markedAsReadDocIds: {}
  }),

  computed: {
    ...mapGetters({
      items: 'watchlistDocuments',
      itemsTotal: 'watchlistDocumentsTotal',
      events: 'watchlistDocumentEvents',
      unreadCount: 'watchlistUnreadDocumentsTotal',
      showLoader: 'showLoader'
    }),
    itemsToSee() {
      return this.filterUnread ? this.items.filter(i => i.unread) : this.items;
    },
    curEvent() {
      return this.events.find(event => event.id === this.curEventId);
    },
    curPeriod() {
      return this.curEvent
        ? this.curEvent.periods.find(period => period.id === this.curPeriodId)
        : null;
    },
    listSummary() {
      if (this.filterUnread) {
        let text = 'Непрочтённые';

        if (this.curPeriod) {
          text +=
            ', ' +
            (this.curPeriod.isFuture
              ? this.curEvent.futureCaption
              : this.curEvent.pastCaption);

          text += ' ' + this.curPeriod.name.toLowerCase();
        }
        return text;
      }
      return 'Все';
    }
  },

  async created() {
    await this.$store.dispatch('getWatchlistDocumentEvents');
    this.events.forEach(event => {
      if (event.unreadCount) {
        if (!this.curEventId) {
          this.curEventId = event.id;
          this.curPeriodId = event.defaultPeriodId;
        } else if (!this.curPeriodId && this.curEventId === event.id) {
          this.curPeriodId = event.defaultPeriodId;
        }
      }
    });
    if (!this.curEventId) {
      this.filterUnread = false;
    }
    // Это нужно для восстановления состояния страницы при принудитеьном 
    // обновлении из браузера
    if(this.$route.query && this.$route.query.mode === 'all') {
      this.curEventId = null;
      this.curPeriodId = null;
      this.filterUnread = false;
    }
    await this.loadItems();
  },

  methods: {
    isItemRead(item) {
      let markedAsRead = this.markedAsReadDocIds[item.document.id];

      return markedAsRead !== undefined ? markedAsRead : !item.unread;
    },

    /**
     * Загружает список документов на контроле пользователя.
     * Метод также получает актуальное значение количества непрочитанных
     * пользователем документов на контроле и обновляет данные событий,
     * если актуальное значение количества непрочитанных документов
     * увеличилось.
     */
    async loadItems() {
      await this.$store.dispatch('getWatchlistDocuments', {
        eventId: this.curEventId,
        periodId: this.curPeriodId,
        limit: this.itemsPerPage,
        offset: this.itemsOffset
      });
      this.markedAsReadDocIds = {};
      if( !this.unreadCount ){
        await this.$store.dispatch('countUnreadWatchlistDocuments');
      }
    },
    onFilterUnreadClick(isActive) {
      this.filterUnread = isActive;
      if (!isActive) {
        this.curEventId = null;
        this.curPeriodId = null;
        // Это и $router.push ниже нужно для сохранения состояния
        // интерфейса при принудительной перезагрузке
        this.$router.push({
          name: 'watchlist',
          query: {
            mode: 'all'
          }
        })
      } else {
        this.$router.push({
          name: 'watchlist',
          query: {
            mode: 'unread'
          }
        })
      }
      this.loadItems();
    },
    onMenuItemClick(evObj) {
      let event = evObj.event
      let period = evObj.period? evObj.period: null

      this.curEventId = event.id;
      this.curPeriodId = period ? period.id : event.defaultPeriodId;
      this.loadItems();
    },
    async onButtonWatchClick(item) {      
      await this.$store.dispatch('setDocumentIsWatched', {
        id: item.document.id,
        state: false
      });
      if (!this.isItemRead(item)) this.$store.dispatch('updateUnreadCount', -1)

      await this.loadItems();
    },
    async toggleReadMark(item) {
      let itemRead = this.isItemRead(item);

      await this.$store.dispatch('toggleWatchedDocumentAsRead', {
        id: item.document.id,
        state: !itemRead
      });
      this.$store.dispatch('updateUnreadCount', itemRead? 1: -1)
      this.$set(this.markedAsReadDocIds, item.document.id, !itemRead);
    },
    handlePaginatorUpdate(obj) {
      if ('limit' in obj) this.itemsPerPage = obj.limit;
      if ('offset' in obj) this.itemsOffset = obj.offset;
      this.loadItems();
    }
  },

  metaInfo: {
    title: 'На контроле'
  }
};
</script>
